<template>
  <div>
    <md-card>
      <md-card-header>
        <span class="md-title">{{ L(titleKey) }}</span>
      </md-card-header>
      <md-card-content>
        <GChart type="LineChart" :data="chartData" :options="chartOptions" />
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  components: { GChart },

  props: {
    titleKey: String,
    data: Array,
    currency: String,
  },

  computed: {
    chartData() {
      return this.data || []
    },

    chartOptions() {
      return {
        tooltip: { trigger: 'focus' },
        aggregationTarget: 'category',
        hAxis: { title: this.L('date') },
        vAxis: { title: `${this.L('cost')} (${this.currency})` },
        focusTarget: 'category',
        pointSize: window.innerWidth > 800 ? 8 : 4,
        legend: { position: 'top' },
        colors: ['#FF0000', '#000000', '#A6A6A6'],
        chartArea: {
          left: window.innerWidth > 800 ? 120 : 60,
          right: 10,
        },
        backgroundColor: 'none',
      }
    },
  },

  methods: {},
}
</script>
